import { render, staticRenderFns } from "./CockpitPersonSelect.vue?vue&type=template&id=1c3f8a17&scoped=true"
import script from "./CockpitPersonSelect.vue?vue&type=script&lang=js"
export * from "./CockpitPersonSelect.vue?vue&type=script&lang=js"
import style0 from "./CockpitPersonSelect.vue?vue&type=style&index=0&id=1c3f8a17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3f8a17",
  null
  
)

export default component.exports